<div class="col item-card radius-to-aba">
  <div class="row">
    <div class="col-12">
      <p style="margin-top: 25px; margin-bottom: 25px; font-size: 25px">Status de Acesso</p>
      <p class="text-muted tab-description">
        Acompanhe o status de cadastro do colaborador nas bases necessárias para liberação de acessos.
      </p>
    </div>
  </div>

  

  <!-- Boxes -->
  <div *ngIf="!loadingStatus" class="row mb-4">
    <ng-container *ngFor="let box of accessBoxes">
    <div class="col-xl-4 col-lg-4 col-md-6 mb-3" >
      <app-box-status-access
        [title]="box.title"
        [icon]="box.icon"
        [description]="box.description"
        [status]="box.status"
        [actionEnabled]="box.actionEnabled"
        [loading]="box.loading"
        (clickButtonAction)="onAtualizar(box)">
      </app-box-status-access>
      <ng-container  *ngIf="box.errorMessage">
        <div class="alert alert-danger box-errormessage-default mt-2 py-2 px-3 mr-4 ml-3 small" role="alert" >
          {{ box.errorMessage }}
        </div>
      </ng-container>
    </div>
    </ng-container>

    <ng-container *ngIf="accessBoxes.length === 0" >

      <div  class="ml-4  alert alert-warning">
        {{ 'Nenhum status de acesso encontrado para este colaborador.' }}
      </div>
    </ng-container>
  </div>


  <!-- Loading -->
  <div class="row mb-4" *ngIf="loadingStatus">
    <div class="col-xl-4 col-lg-4 col-md-6 mb-3" *ngFor="let box of [1,2,3]">
      <div class="item-card p-3 h-100 d-flex flex-column">
        <div class="d-flex align-items-center mb-2"></div>
        <p class="text-muted box-description placeholder-glow">
          <span class="skeleton col-7" style="height: 30px;"></span>
        </p>
        <div class="d-flex align-items-center justify-content-between mt-auto">
          <div class="w-100">
            <span class="skeleton col-7" style="height: 10px;"></span>
            <span class="skeleton col-7" style="height: 10px;"></span>
          </div>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </div>
      </div>
    </div>
  </div>
</div>
